import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=879e495c&scoped=true"
import script from "./thankyou.vue?vue&type=script&lang=js"
export * from "./thankyou.vue?vue&type=script&lang=js"
import style0 from "./thankyou.vue?vue&type=style&index=0&id=879e495c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879e495c",
  null
  
)

export default component.exports